import * as z from "zod";

import { ReferrerPayoutSchema } from "../shared/payout";

export const getPayouts = {
  name: "getPayouts" as const,
  input: z.object({}),
  output: z.object({ payouts: z.array(ReferrerPayoutSchema) }),
};
